import { StoreDetails, storeDealer } from '@appTypes/StoreDetails';
import { Icon } from '@components/style/Icon';
import { Typography } from '@components/style/Typography';
import { theme } from '@theme';
import { FC, useState } from 'react';
import { DealerIdsWrappingDiv, RightAlignedDiv, TextWrappingDiv, Wrapper } from './Style';

type StoreProps = {
  data: StoreDetails;
  showInactiveStores: boolean;
  isPrimaryUser: boolean;
  isShadowUser: boolean;
  activeStoresCount: number;
  openedFromModal: boolean;
  handleStoreSelectionAndNavigation: (storeCode: string) => void;
};

const Store: FC<StoreProps> = (props) => {
  const [storeColor, setStoreColor] = useState(theme.palette.grey);
  const [dealerColor, setDealerColor] = useState(theme.palette.dusty);

  const handleOver = () => {
    setStoreColor(theme.palette.white);
    setDealerColor(theme.palette.white);
  };

  const handleLeave = () => {
    setStoreColor(theme.palette.grey);
    setDealerColor(theme.palette.dusty);
  };

  const updateStoreName = (storeName: string) => {
    storeName = storeName?.replace('Mini', 'MINI');
    storeName = storeName?.replace('Infiniti', 'INFINITI');
    return storeName;
  };

  const getDealerIds = (store: storeDealer[]) => {
    // sort dealerIds alphabetically
    store.sort((a, b) => (a.dealerId < b.dealerId ? -1 : 1));

    // push all OB dealerIds to the end of the list
    store.push(
      store.splice(
        store.findIndex((v) => v.dealerId.startsWith('OB')),
        1,
      )[0],
    );
    const dealerIdsList = store.reduce((list, dealer) => {
      list += list.length > 0 ? ', ' + dealer.dealerId : dealer.dealerId;
      return list;
    }, '');

    return dealerIdsList;
  };

  return (
    <Wrapper
      isPrimaryUser={props.isPrimaryUser}
      isShadowUser={props.isShadowUser}
      data-testid='store-details'
    >
      <div
        className='card'
        data-testid='store-card'
        style={{ borderWidth: 0 }}
        onMouseOver={() => handleOver()}
        onMouseLeave={() => handleLeave()}
        onClick={() => props.handleStoreSelectionAndNavigation(props.data.storeCode)}
        title={updateStoreName(props.data.storeName)}
      >
        <div className='store'>
          <TextWrappingDiv data-testid='store-name'>
            {props.isPrimaryUser && !props.isShadowUser && (
              <Typography
                data-testid='store-code'
                size={theme.typography.h4}
                fontWeight={theme.typography.fontWeights.semibold}
                color={storeColor}
                marginRight={10}
              >
                {props.data.storeCode}
              </Typography>
            )}
            <Typography
              size={theme.typography.h4}
              fontWeight={theme.typography.fontWeights.semibold}
              color={storeColor}
            >
              {updateStoreName(props.data.storeName)}
            </Typography>
          </TextWrappingDiv>
          <RightAlignedDiv>
            <Icon
              color={dealerColor}
              data-testid='store-arrow-icon'
              type='angle-right'
              size={16}
              fontWeight={theme.typography.fontWeights.semibold}
            />
          </RightAlignedDiv>
        </div>
        {props.isPrimaryUser && !props.isShadowUser && (
          <DealerIdsWrappingDiv data-testid='store-dealers'>
            <Typography
              size={theme.typography.h5}
              fontWeight={theme.typography.fontWeights.medium}
              color={dealerColor}
            >
              {getDealerIds(
                props.showInactiveStores
                  ? props.data.storeDealers.filter((e) => e.isActive === false)
                  : props.data.storeDealers.filter((e) => e.isActive === true),
              )}
            </Typography>
          </DealerIdsWrappingDiv>
        )}
      </div>
    </Wrapper>
  );
};

export default Store;
